// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatFeedbackForm-moduleform__kT3TF";
var _2 = "GretaAIChatFeedbackForm-moduletitle__LjSEB";
export { _1 as "form", _2 as "title" }
